export default {
  title: '! Pedidos pausados hasta las {{time}}',
  button: 'Reanudar',
  labels: {
    rest_of_day: 'resto del día',
  },
};
